export default (state) => state.restricted._session.session_proxy;
